import type { Theme } from '@mui/system';

export const styles = {
  button: (theme: Theme) => ({
    ...theme.palette.button,
    justifyContent: 'space-evenly',
    minWidth: 'auto',
  }),
  drawerItem: {
    border: '1px solid #ccc',
    borderRadius: '0.5rem',
    marginBottom: (theme: Theme) => theme.spacing(1),
    padding: (theme: Theme) => theme.spacing(1),
    background: 'transparent',
    transition: 'background 0.2s, border 0.2s',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  label: {
    display: 'flex',
    flex: '1 1 auto',
    justifyContent: 'center',
  },
  downloadIcon: {
    color: (theme: Theme) => theme.palette.baseColors.deepSeaNavy.c100,
    width: '1.5rem',
    height: '1.5rem',
  },
  errorStateContainer: {
    display: 'flex',
    height: '100%',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    p: 4,
    textAlign: 'center',
    minHeight: 200,
  },
  errorStateIcon: {
    fontSize: 64,
    color: (theme: Theme) => theme.palette.warning.main,
    opacity: 0.25,
    mb: 2,
  },
  errorStateText: {
    color: (theme: Theme) => theme.palette.text.primary,
    mb: 1,
  },
  errorStateButton: {
    fontSize: '0.675rem',
  },
  emptyStateContainer: {
    display: 'flex',
    height: '100%',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    p: 4,
    textAlign: 'center',
    minHeight: 200,
    color: (theme: Theme) => theme.palette.baseColors.deepSeaNavy.c100o15,
  },
  emptyStateIcon: {
    fontSize: 64,
  },
  emptyStateText: {
    color: (theme: Theme) => theme.palette.text.primary,
    mb: 1,
  },
  drawerHeaderContainer: {
    position: 'sticky',
    top: 0,
    backgroundColor: (theme: Theme) => theme.palette.background.paper,
    zIndex: 10,
  },
  drawerHeaderContent: {
    display: 'grid',
    gridTemplateColumns: '1fr auto auto',
    alignItems: 'center',
    p: 2,
  },
  drawerHeaderTitle: {
    fontWeight: 600,
    color: (theme: Theme) => theme.palette.text.primary,
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    margin: '0.25rem 0 0',
    lineHeight: 1,
  },
  drawerHeaderRefreshButton: {
    color: (theme: Theme) => theme.palette.text.secondary,
    '&:hover': {
      backgroundColor: (theme: Theme) => theme.palette.action.hover,
    },
  },
  drawerHeaderCloseButton: {
    color: (theme: Theme) => theme.palette.text.secondary,
    '&:hover': {
      backgroundColor: (theme: Theme) => theme.palette.action.hover,
    },
  },
  drawerHeaderDivider: {
    mb: 0,
  },
  historyList: {
    p: 2,
    marginTop: 0,
  },
  drawerBackdrop: {
    backgroundColor: (theme: Theme) => `${theme.palette.baseColors.deepSeaNavy.c100}75`,
  },
  drawerContent: {
    display: 'flex',
    flexDirection: 'column',
  },
  listItemIcon: {
    minWidth: 'auto',
    padding: (theme: Theme) => theme.spacing(0, 1),
  },
};
